import { render, staticRenderFns } from "./Requisites.vue?vue&type=template&id=dc34d85a"
import script from "./Requisites.vue?vue&type=script&lang=js"
export * from "./Requisites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports